import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

/**
 * Same blank-terms test as the v2 block (`PresentationNext/blocks/Terms/TermsIsEmpty`) — see that
 * file for why a single `.replace('<p></p>', '')` was not enough (ENG-1494).
 */
export default function isEmpty({ quote }: PresentationIsEmptyProps) {
  const hasContent = !!quote?.terms?.content && !isHtmlEmpty(quote.terms.content)
  const isAccepted = quote?.status?.value === 'accepted'
  const hasSignature = !!quote?.signatures?.customer

  return !hasContent && !(isAccepted && hasSignature)
}
